/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var FileSaver_min = createCommonjsModule(function (module, exports) {
  (function (a, b) {
    b();
  })(commonjsGlobal, function () {
    function b(a, b) {
      return "undefined" == typeof b ? b = {
        autoBom: !1
      } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
        autoBom: !b
      }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob(["\uFEFF", a], {
        type: a.type
      }) : a;
    }

    function c(b, c, d) {
      var e = new XMLHttpRequest();
      e.open("GET", b), e.responseType = "blob", e.onload = function () {
        a(e.response, c, d);
      }, e.onerror = function () {
        console.error("could not download file");
      }, e.send();
    }

    function d(a) {
      var b = new XMLHttpRequest();
      b.open("HEAD", a, !1);

      try {
        b.send();
      } catch (a) {}

      return 200 <= b.status && 299 >= b.status;
    }

    function e(a) {
      try {
        a.dispatchEvent(new MouseEvent("click"));
      } catch (c) {
        var b = document.createEvent("MouseEvents");
        b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
      }
    }

    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof commonjsGlobal && commonjsGlobal.global === commonjsGlobal ? commonjsGlobal : void 0,
        a = f.saveAs || ("object" != typeof window || window !== f ? function () {} : "download" in HTMLAnchorElement.prototype ? function (b, g, h) {
      var i = f.URL || f.webkitURL,
          j = document.createElement("a");
      g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function () {
        i.revokeObjectURL(j.href);
      }, 4E4), setTimeout(function () {
        e(j);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function (f, g, h) {
      if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);else if (d(f)) c(f, g, h);else {
        var i = document.createElement("a");
        i.href = f, i.target = "_blank", setTimeout(function () {
          e(i);
        });
      }
    } : function (a, b, d, e) {
      if (e = e || open("", "_blank"), e && (e.document.title = e.document.body.innerText = "downloading..."), "string" == typeof a) return c(a, b, d);
      var g = "application/octet-stream" === a.type,
          h = /constructor/i.test(f.HTMLElement) || f.safari,
          i = /CriOS\/[\d]+/.test(navigator.userAgent);

      if ((i || g && h) && "object" == typeof FileReader) {
        var j = new FileReader();
        j.onloadend = function () {
          var a = j.result;
          a = i ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), e ? e.location.href = a : location = a, e = null;
        }, j.readAsDataURL(a);
      } else {
        var k = f.URL || f.webkitURL,
            l = k.createObjectURL(a);
        e ? e.location = l : location.href = l, e = null, setTimeout(function () {
          k.revokeObjectURL(l);
        }, 4E4);
      }
    });
    f.saveAs = a.saveAs = a, module.exports = a;
  });
});
var FileSaver_min_1 = FileSaver_min.saveAs;

function isUrlAbsolute(url) {
  if (!url) {
    throw new Error('Url absolute check needs a proper url');
  }

  if (url.indexOf('//') === 0) {
    return true;
  } // URL is protocol-relative (= absolute)


  if (url.indexOf('://') === -1) {
    return false;
  } // URL has no protocol (= relative)


  if (url.indexOf('.') === -1) {
    return false;
  } // URL does not contain a dot, i.e. no TLD (= relative, possibly REST)


  if (url.indexOf('/') === -1) {
    return false;
  } // URL does not contain a single slash (= relative)


  if (url.indexOf(':') > url.indexOf('/')) {
    return false;
  } // The first colon comes after the first slash (= relative)


  if (url.indexOf('://') < url.indexOf('.')) {
    return true;
  } // Protocol is defined before first dot (= absolute)


  return false; // Anything else must be relative
}

var API_GATEWAY = process.env.API_GATEWAY || process.env.REACT_APP_API_GATEWAY || 'https://gateway.api.dev.globalfishingwatch.org';
var USER_TOKEN_STORAGE_KEY = 'GFW_API_USER_TOKEN';
var USER_REFRESH_TOKEN_STORAGE_KEY = 'GFW_API_USER_REFRESH_TOKEN';
var AUTH_PATH = 'auth';

var processStatus = function processStatus(response) {
  return response.status >= 200 && response.status < 300 ? Promise.resolve(response) : Promise.reject({
    status: response.status,
    message: response.statusText
  });
};

var parseJSON = function parseJSON(response) {
  return response.json();
};

var isUnauthorizedError = function isUnauthorizedError(error) {
  return error && error.status > 400 && error.status < 403;
};

var GFWAPI =
/** @class */
function () {
  function GFWAPI(_a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.debug,
        debug = _c === void 0 ? false : _c,
        _d = _b.baseUrl,
        baseUrl = _d === void 0 ? API_GATEWAY : _d,
        _e = _b.tokenStorageKey,
        tokenStorageKey = _e === void 0 ? USER_TOKEN_STORAGE_KEY : _e,
        _f = _b.refreshTokenStorageKey,
        refreshTokenStorageKey = _f === void 0 ? USER_REFRESH_TOKEN_STORAGE_KEY : _f;

    this.token = '';
    this.refreshToken = '';
    this.dataset = '';
    this.maxRefreshRetries = 1;
    this.debug = debug;
    this.baseUrl = baseUrl;
    this.storageKeys = {
      token: tokenStorageKey,
      refreshToken: refreshTokenStorageKey
    };
    this.setToken(localStorage.getItem(tokenStorageKey) || '');
    this.setRefreshToken(localStorage.getItem(refreshTokenStorageKey) || '');
    this.logging = null;

    if (debug) {
      console.log('GFWAPI: GFW API Client initialized with the following config', this.getConfig());
    }
  }

  GFWAPI.prototype.getBaseUrl = function () {
    return this.baseUrl;
  };

  GFWAPI.prototype.getLoginUrl = function (callbackUrl, client) {
    if (client === void 0) {
      client = 'gfw';
    }

    return this.baseUrl + "/" + AUTH_PATH + "?client=" + client + "&callback=" + callbackUrl;
  };

  GFWAPI.prototype.getConfig = function () {
    return {
      debug: this.debug,
      baseUrl: this.baseUrl,
      storageKeys: this.storageKeys,
      token: this.getToken(),
      refreshToken: this.getRefreshToken()
    };
  };

  GFWAPI.prototype.setConfig = function (config) {
    var _a = config.debug,
        debug = _a === void 0 ? this.debug : _a,
        _b = config.baseUrl,
        baseUrl = _b === void 0 ? this.baseUrl : _b,
        _c = config.dataset,
        dataset = _c === void 0 ? this.dataset : _c;
    this.debug = debug;
    this.baseUrl = baseUrl;
    this.dataset = dataset;
  };

  GFWAPI.prototype.getToken = function () {
    return this.token;
  };

  GFWAPI.prototype.setToken = function (token) {
    this.token = token;
    localStorage.setItem(this.storageKeys.token, token);

    if (this.debug) {
      console.log('GFWAPI: updated token with', token);
    }
  };

  GFWAPI.prototype.getRefreshToken = function () {
    return this.refreshToken;
  };

  GFWAPI.prototype.setRefreshToken = function (refreshToken) {
    this.refreshToken = refreshToken;
    localStorage.setItem(this.storageKeys.refreshToken, refreshToken);

    if (this.debug) {
      console.log('GFWAPI: updated refreshToken with', refreshToken);
    }
  };

  GFWAPI.prototype.getTokensWithAccessToken = function (accessToken) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , fetch(this.baseUrl + "/" + AUTH_PATH + "/token?access-token=" + accessToken).then(processStatus).then(parseJSON)];
      });
    });
  };

  GFWAPI.prototype.getTokenWithRefreshToken = function (refreshToken) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , fetch(this.baseUrl + "/" + AUTH_PATH + "/token/reload", {
          headers: {
            'refresh-token': refreshToken
          }
        }).then(processStatus).then(parseJSON)];
      });
    });
  };

  GFWAPI.prototype.fetch = function (url, options) {
    if (options === void 0) {
      options = {};
    }

    return this._internalFetch(url, options);
  };

  GFWAPI.prototype.download = function (downloadUrl, fileName) {
    if (fileName === void 0) {
      fileName = 'download';
    }

    return this._internalFetch(downloadUrl, {
      json: false
    }).then(function (res) {
      return res.blob();
    }).then(function (blob) {
      FileSaver_min_1(blob, fileName);
      return true;
    }).catch(function (e) {
      return false;
    });
  };

  GFWAPI.prototype._internalFetch = function (url, options, refreshRetries, waitLogin) {
    if (options === void 0) {
      options = {};
    }

    if (refreshRetries === void 0) {
      refreshRetries = 0;
    }

    if (waitLogin === void 0) {
      waitLogin = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var e_1, _a, method, _b, body, _c, headers, _d, json_1, signal, _e, dataset, prefix, fetchUrl, data, e_2, token, e_3, e_4;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            _f.trys.push([0, 14,, 15]);

            if (!(this.logging && waitLogin)) return [3
            /*break*/
            , 4];
            _f.label = 1;

          case 1:
            _f.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.logging];

          case 2:
            _f.sent();

            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _f.sent();
            throw new Error("Fetch resource not executed as the logged failed with url: " + url);

          case 4:
            _f.trys.push([4, 6,, 13]);

            _a = options.method, method = _a === void 0 ? 'GET' : _a, _b = options.body, body = _b === void 0 ? null : _b, _c = options.headers, headers = _c === void 0 ? {} : _c, _d = options.json, json_1 = _d === void 0 ? true : _d, signal = options.signal, _e = options.dataset, dataset = _e === void 0 ? this.dataset : _e;

            if (this.debug) {
              console.log("GFWAPI: Fetching url: " + url);
            }

            prefix = "" + (isUrlAbsolute(url) ? '' : this.baseUrl);
            fetchUrl = prefix + (dataset ? "/datasets/" + this.dataset : '') + url;
            return [4
            /*yield*/
            , fetch(fetchUrl, _assign(_assign({
              method: method,
              signal: signal
            }, body && {
              body: JSON.stringify(body)
            }), {
              headers: _assign(_assign({}, headers), {
                Authorization: "Bearer " + this.getToken()
              })
            })).then(processStatus).then(function (res) {
              return json_1 ? parseJSON(res) : res;
            })];

          case 5:
            data = _f.sent();
            return [2
            /*return*/
            , data];

          case 6:
            e_2 = _f.sent();
            if (!(refreshRetries <= this.maxRefreshRetries)) return [3
            /*break*/
            , 11];
            if (!(e_2.status === 401 || e_2.status === 403)) return [3
            /*break*/
            , 10];

            if (this.debug) {
              console.log("GFWAPI: Trying to refresh the token attempt: " + refreshRetries);
            }

            _f.label = 7;

          case 7:
            _f.trys.push([7, 9,, 10]);

            return [4
            /*yield*/
            , this.getTokenWithRefreshToken(this.getRefreshToken())];

          case 8:
            token = _f.sent().token;
            this.setToken(token);

            if (this.debug) {
              console.log("GFWAPI: Token refresh worked! trying to fetch again " + url);
            }

            return [3
            /*break*/
            , 10];

          case 9:
            e_3 = _f.sent();

            if (this.debug) {
              console.warn("GFWAPI: Error fetching " + url, e_3);
            }

            localStorage.removeItem(this.storageKeys.token);
            localStorage.removeItem(this.storageKeys.refreshToken);
            e_3.refreshError = true;
            throw e_3;

          case 10:
            return [2
            /*return*/
            , this._internalFetch(url, options, ++refreshRetries, waitLogin)];

          case 11:
            if (this.debug) {
              if (refreshRetries >= this.maxRefreshRetries) {
                console.log("GFWAPI: Attemps to retry the request excedeed");
              }

              console.warn("GFWAPI: Error fetching " + url, e_2);
            }

            throw e_2;

          case 12:
            return [3
            /*break*/
            , 13];

          case 13:
            return [3
            /*break*/
            , 15];

          case 14:
            e_4 = _f.sent();

            if (this.debug) {
              console.warn("GFWAPI: Error fetching " + url, e_4);
            }

            throw e_4;

          case 15:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GFWAPI.prototype.fetchUser = function () {
    return __awaiter(this, void 0, void 0, function () {
      var user, e_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this._internalFetch("/" + AUTH_PATH + "/me", {
              dataset: false
            }, 0, false)];

          case 1:
            user = _a.sent();
            return [2
            /*return*/
            , user];

          case 2:
            e_5 = _a.sent();
            console.warn(e_5);
            throw new Error('Error trying to get user data');

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GFWAPI.prototype.login = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, accessToken, _b, refreshToken;

      var _this = this;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = params.accessToken, accessToken = _a === void 0 ? null : _a, _b = params.refreshToken, refreshToken = _b === void 0 ? this.getRefreshToken() : _b;
            this.logging = new Promise(function (resolve, reject) {
              return __awaiter(_this, void 0, void 0, function () {
                var tokens, e_6, msg, user, e_7, token, user, e_8, msg;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      if (!accessToken) return [3
                      /*break*/
                      , 4];

                      if (this.debug) {
                        console.log("GFWAPI: Trying to get tokens using access-token");
                      }

                      _a.label = 1;

                    case 1:
                      _a.trys.push([1, 3,, 4]);

                      return [4
                      /*yield*/
                      , this.getTokensWithAccessToken(accessToken)];

                    case 2:
                      tokens = _a.sent();
                      this.setToken(tokens.token);
                      this.setRefreshToken(tokens.refreshToken);

                      if (this.debug) {
                        console.log("GFWAPI: access-token valid, tokens ready");
                      }

                      return [3
                      /*break*/
                      , 4];

                    case 3:
                      e_6 = _a.sent();

                      if (!this.getToken() && !this.getRefreshToken()) {
                        msg = isUnauthorizedError(e_6) ? 'Invalid access token' : 'Error trying to generate tokens';

                        if (this.debug) {
                          console.warn("GFWAPI: " + msg);
                        }

                        reject(new Error(msg));
                        return [2
                        /*return*/
                        , null];
                      }

                      return [3
                      /*break*/
                      , 4];

                    case 4:
                      if (!this.getToken()) return [3
                      /*break*/
                      , 8];

                      if (this.debug) {
                        console.log("GFWAPI: Trying to get user with current token");
                      }

                      _a.label = 5;

                    case 5:
                      _a.trys.push([5, 7,, 8]);

                      return [4
                      /*yield*/
                      , this.fetchUser()];

                    case 6:
                      user = _a.sent();

                      if (this.debug) {
                        console.log("GFWAPI: Token valid, user data ready:", user);
                      }

                      resolve(user);
                      return [2
                      /*return*/
                      , user];

                    case 7:
                      e_7 = _a.sent();

                      if (this.debug) {
                        console.warn('GFWAPI: Token expired, trying to refresh', e_7);
                      }

                      return [3
                      /*break*/
                      , 8];

                    case 8:
                      if (!refreshToken) return [3
                      /*break*/
                      , 13];

                      if (this.debug) {
                        console.log("GFWAPI: Token wasn't valid, trying to refresh");
                      }

                      _a.label = 9;

                    case 9:
                      _a.trys.push([9, 12,, 13]);

                      return [4
                      /*yield*/
                      , this.getTokenWithRefreshToken(refreshToken)];

                    case 10:
                      token = _a.sent().token;
                      this.setToken(token);

                      if (this.debug) {
                        console.log("GFWAPI: Refresh token OK, fetching user");
                      }

                      return [4
                      /*yield*/
                      , this.fetchUser()];

                    case 11:
                      user = _a.sent();

                      if (this.debug) {
                        console.log("GFWAPI: Login finished, user data ready:", user);
                      }

                      resolve(user);
                      return [2
                      /*return*/
                      , user];

                    case 12:
                      e_8 = _a.sent();
                      msg = isUnauthorizedError(e_8) ? 'Invalid refresh token' : 'Error trying to refreshing the token';
                      console.warn(e_8);

                      if (this.debug) {
                        console.warn("GFWAPI: " + msg);
                      }

                      reject(new Error(msg));
                      return [2
                      /*return*/
                      , null];

                    case 13:
                      resolve(null);
                      return [2
                      /*return*/
                      , null];
                  }
                });
              });
            });
            return [4
            /*yield*/
            , this.logging];

          case 1:
            return [2
            /*return*/
            , _c.sent()];
        }
      });
    });
  };

  GFWAPI.prototype.logout = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e_9;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            if (this.debug) {
              console.log("GFWAPI: Logout - tokens cleaned");
            }

            this.setToken('');
            this.setRefreshToken('');
            return [4
            /*yield*/
            , this.fetch("/" + AUTH_PATH + "/logout")];

          case 1:
            _a.sent();

            if (this.debug) {
              console.log("GFWAPI: Logout invalid session api OK");
            }

            return [2
            /*return*/
            , true];

          case 2:
            e_9 = _a.sent();

            if (this.debug) {
              console.warn("GFWAPI: Logout invalid session fail");
            }

            throw new Error('Error on the logout proccess');

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return GFWAPI;
}();

var apiClient = new GFWAPI();
export default apiClient;
export { GFWAPI, USER_REFRESH_TOKEN_STORAGE_KEY, USER_TOKEN_STORAGE_KEY };